<template>
    <button
            :type="type"
            class="btn btn-success"
            :disabled="loading"
            @click="$emit('click', $event)"
    >
        <small-loader v-if="loading"></small-loader>
        <span>
            {{title}}
        </span>
    </button>
</template>

<script>
  import SmallLoader from '../Loaders/SmallLoader'

  export default {
    name: 'btn',
    components: {SmallLoader},
    props: {
      title: {
        type: String,
        default: 'Сохранить'
      },
      loading: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'submit'
      }
    }
  }
</script>

<style lang="scss" scoped>

    .btn {
        position: relative;
        border-radius: 40px;
        padding: 6px 30px;
        height: 40px;
        &-success {
            color: #fff;
            background-color: #00b770;
        }
        &:disabled {
            opacity: 0.7;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/form/Btn.vue